module.exports = __webpack_public_path__ + "static/media/ic_eraser.01e6c59b.svg";